import { EngFlag, RusFlag, UzbFlag } from "../assets/icons";
import { ILanguage } from "./types";

export const languageOptions: ILanguage[] = [
  { id: "1", label: "O’zbekcha", icon: <UzbFlag />, value: "uz" },
  { id: "2", label: "Русский", icon: <RusFlag />, value: "ru" },
  { id: "3", label: "English", icon: <EngFlag />, value: "en" },
];
